import React, {Component} from 'react';

class ArticleDemo extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const divStyle = {
      textAlign: 'center',
      margin: 30,
    };
    const formStyle = {
      margin: 30,
    };
    const buttonStyle = {
      width: 230,
      height: 48,
      borderRadius: 50,
      fontSize: 15,
      backgroundColor: '#0070ba',
      color: '#ffffff',
      margin: 30,
    };
    const textStyle = {
      width: 1116,
      fontSize: 20,
    };
    const newcsrf = document.body.getAttribute('data-token');
    return (
      <div style={divStyle}>
        <h1> {'To test article view'} </h1>
        <form action={`postarticle?q=${newcsrf}`} method="post" style={formStyle}>
          <textarea name="articlecontentposted" rows={20} ref={(input) => this.input = input}
            placeholder="Input article API content" style={textStyle} />
          <br />
          <button type="submit" style={buttonStyle}>{'Submit'}</button>
        </form>
      </div>
    );
  }
}

export default ArticleDemo;
